/**
 * Public barrel export for SortDropdown
 * @module components/shared/search-modal/SortDropdown
 */

export { default } from "./SortDropdownView";
